import React from "react";
import { Container, Typography, Box, Divider, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

import { formatRichText } from "../utils/formatRichText";
function formatText(rawText) {
  return formatRichText(rawText).map((paragraph, index) => (
    <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
  ));
}

const Policies = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('privacy_policy')}
      </Typography>

      <Box sx={{ mt: 4 }}>
        {formatText(t('public_privacy_policy'))}
      </Box>
    </Container>
  );
};

export default Policies;
